import React from 'react';
import { Button, Menu, MenuItem, MenuList, ListItemText, ListItemIcon } from '@mui/material';
import EmailIcon from '@mui/icons-material/Email';
import SendMessagePreviewModal from './SendMessagePreviewModal';
import toast from 'react-hot-toast';
import { sendOrderMail } from '../../../../../../services/request';
import { useParameterizedQuery } from 'react-fetching-library';
import { useSelector } from 'react-redux';


export const EmailButton = ({ formik }) => {
  const { module } = useSelector(state => state.app);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const [openModal, setOpenModal] = React.useState(false);
  const [notificationType, setNotificationType] = React.useState();
  const { order } = useSelector(state => state.orderData);

  const { query: sendOrderEmailQuery } = useParameterizedQuery(sendOrderMail);


  const handleSend = async data => {
    const { error, loading } = await sendOrderEmailQuery(order.id, data);
    if (!error && !loading) {
      toast.success('Email został wysłany');
      setOpenModal(false);
    }

    if (error) {
      toast.error('Nie udało się wysłać emaila');
    }
  };

  const handleOpen = type => {
    setNotificationType(type);
    setOpenModal(true);
  };

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Button
        id="basic-button"
        disabled={false}
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        variant="contained"
        onClick={handleClick}
      >
        <EmailIcon sx={{ mr: 2 }}/>
        Wyślij e-mail
      </Button>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button'
        }}
      >
        <MenuItem onClick={() => handleOpen('AMES')}>
          <ListItemIcon>
            <EmailIcon />
          </ListItemIcon>
          <ListItemText>
              Dowolna treść
          </ListItemText>
        </MenuItem>
        {formik.values.classification == 1
          ? <MenuItem onClick={() => handleOpen('SCQC')}>
            <ListItemIcon>
              <EmailIcon/>
            </ListItemIcon>
            <ListItemText>
                Potwierdzenie kwalifikacji
            </ListItemText>
          </MenuItem>
          : null}
        {module == 'obozy' && <MenuItem onClick={() => handleOpen('SHAC')}>
          <ListItemIcon>
            <EmailIcon/>
          </ListItemIcon>
          <ListItemText>
                Potwierdzenie zakwaterowania
          </ListItemText>
        </MenuItem>}
      </Menu>
      {openModal
        ? <SendMessagePreviewModal
          handleSend={handleSend}
          // handleSend={() => console.log('xxx')}
          handleClose={() => setOpenModal(false)}
          type={notificationType}
          showMessage={false} />
        : null}
    </>
  );
};
